var icon = require('vue-svgicon')
icon.register({
  'ks-icon-trash': {
    width: 128,
    height: 128,
    viewBox: '0 0 128 128',
    data: '<path pid="0" d="M96.67 26.67H80.33L75.67 22H52.33l-4.67 4.67H31.33V36h65.34M36 96.67a9.33 9.33 0 0 0 9.33 9.33h37.34A9.33 9.33 0 0 0 92 96.67v-56H36z"/>'
  }
})
